module.exports = __webpack_public_path__ + "img/DE06294.7b47db99.png";